import React from 'react';

export const Info_nav = ({}) => {
      return (
      <>
            Interaction with the animation is similar to any map interface. Via
            mouse or touchscreen, you can zoom & pan the GIF as you would Google
            maps or similar. Use the buttons on the bottom left corner to enter
            fullscreen mode, reset the view, and zoom in and out. Use the
            control bar in the bottom center to play, pause, and step through
            the animation.
            <br></br>
            <br></br>
            <br></br>
            <h5>Tiles, Subtiles, & Properties</h5>
            <div className="info-line-container">
              <span className="info-line"></span>
            </div>
            <h6>Versions</h6>
            Toggle between the different versions of <i>TODEM</i> by selecting the green 
            numbers at the top center of the screen below the <i>TODEM</i> heading. 
            <br></br>
            <h6>Tiles</h6>
            Mousing over the artwork displays a yellow highlight box,
            identifying one of 1000 knolled regions called <i>Tiles,</i> the
            objects available for acquisition as NFTs. Click on a Tile to select
            it. Selecting a Tile opens a sidebar on the right hand side of the
            page.
            <br></br>
            <h6>Sidebar</h6>
            The sidebar displays the selected region, along with previous, next,
            and shuffle controls to navigate between Tiles. It also displays
            important Tile properties including price in Ethereum and USD, label
            of frame 33, dimensions in pixels, class (A, B, C, or D), and the
            number of subtiles within the selected Tile.
            <br></br>
            <h6>Subtiles</h6>
            Once selected, mousing within the Tile displays a blue highlight box
            to indicate areas called <i>Subtiles</i>. Each subtile contains a
            unique ten-second AI-generated animation determined by a separate
            AI-generated text-prompt. Mousing over (or selecting) a subtile
            opens a secondary window which reveals the specific prompt used
            to generate its animation.
            <br></br>
            <h6>Popout</h6>
            Use the popout button in the bottom left corner of the sidebar to
            reveal a more detailed view of individual Tiles, their subtile
            prompts, and additional interesting properties.
            <br></br>
            <br></br>
            <h5>Grid Overlays & Search</h5>
            <div className="info-line-container">
              <span className="info-line"></span>
            </div>
            <h6>Grid Overlay</h6>
            Click on the gridded box in the top left corner to cycle through
            overlay modes.
            <br></br>
            <br></br>
            <i>
              <span style={{ color: '#7e86bc' }}>Overlay: Availability</span>
            </i>{' '}
            displays Tiles by their blockchain availability.
            <li>White Tiles are available and have not yet been minted.</li>
            <li>Red Tiles have been previously minted.</li>
            <li>Gold indicates Tiles that you own.</li>
            <br></br>
            <i>
              <span style={{ color: '#7e86bc' }}>Overlay: Class</span>
            </i>{' '}
            color-coded Tiles in one of four classes proportional to the US
            distribution of wealth. (Source: FRED Q4 2022)
            <li>
              <span style={{ color: '#ddb348' }}>Class A</span> Red, 10 Tiles,
              32.15% of pixel area
            </li>
            <li>
              <span style={{ color: '#ddb348' }}>Class B</span> Yellow, 90
              Tiles, 38.04% of pixel area
            </li>
            <li>
              <span style={{ color: '#ddb348' }}>Class C</span> Blue, 400 Tiles,
              26.06% of pixel area
            </li>
            <li>
              <span style={{ color: '#ddb348' }}>Class D</span> White, 500
              Tiles, 3.75% of pixel area
            </li>
            <br></br>
            <br></br>
            <i>
              <span style={{ color: '#7e86bc' }}>Overlay: Grid</span>
            </i>{' '}
            displays the borders of all Tile regions.
            <br></br>
            <br></br>
            <h6>Search</h6>
            Use the search bar to discover Tiles by searching for words present
            in subtile prompts or by Tile number.
            <br></br>
            <br></br>
      </>
)}

export default Info_nav;